export const QueryKeys = {
  PROFILE: "profile",
  PUBLIC_USER_PROFILE: "public-user-profile",
  EXPERIENCES: "experiences",
  BANK_ACCOUNT: "bank-account",
  CERTIFICATIONS: "certifications",
  SHIFT_LIST: "shift-list",
  BUSINESS_PROFILE: "business-profile",
  DASHBOARD: "DASHBOARD",
  SCHEDULE: "SCHEDULE",
  SEARCH: "SEARCH",
  BUSINESS_REVIEWS: "BUSINESS_REVIEWS",
  WORKER_REVIEWS: "WORKER_REVIEWS",
  OFFERS_LIST: "OFFERS_LIST",
  MESSAGES: "MESSAGES",
  PAYMENTS: "PAYMENTS",
  FINANCE_SUMMARY: "FINANCE_SUMMARY",
  STARRED_WORKERS: "STARRED_WORKERS",
  STARRED_WORKER_STATUS: "STARRED_WORKER_STATUS",
  PREVIOUS_WORKERS: "PREVIOUS_WORKERS",
  UPCOMING_SHIFTS: "UPCOMING_SHIFTS",
  DASHBOARD_WEEK: "DASHBOARD_WEEK",
  ROSTER: "ROSTER",
  ATTENTION: "ATTENTION",
  WORKER_ATTENTION: "WORKER_ATTENTION",
  WORKER_NEARBY: "WORKER_NEARBY",
  EVENTS: "EVENTS",
  PENDING_REVIEW: "PENDING_REVIEW",
  WORKER_SHIFT_HISTORY: "WORKER_SHIFT_HISTORY",
  BILLING_STATUS: "BILLING_STATUS",
  BILLING_SETUP_INTENT: "BILLING_SETUP_INTENT",
};
